module.exports = __webpack_public_path__ + "img/R05_OFF 2.c32a5738.jpg";